const fonts = {
  code: "fira Code, monospace",
  proxima: "proxima-nova, sans-serif"
};
const space = [0, 8, 16, 24, 32, 48, 64, 76, 128, 256];
const colors = {
  white: "#D2DEE7",
  lightgray: "#f6f6ff",
  greyBlue: "#4B6479",
  darkBlue: "#011627",
  glassBlue: "rgba(94,129,206,0.32)",
  accentBlue: "#61DAFB",
  accentGreen: "#ADDB67",
  accentPurple: "#C792EA",
  accentRed: "#D3423E",
  mustard: "#ECC48D"
};
const stateColors = {
  active: colors.white,
  inactive: colors.greyBlue,
  passive: colors.greyBlue
};
const otherColors = {
  background: colors.darkBlue,
  lines: colors.glassBlue
};
const breakpoints = [40, 52, 64, 80, 96].map(c => `${c}em`);
export const theme = {
  fontSizes: [12, 16, 24, 32, 48, 64],
  fontWeights: [100, 400, 700],
  breakpoints: breakpoints,
  colors: { ...colors, ...stateColors, ...otherColors },
  borders: ["none", "1px solid"],
  Button: {
    fontFamily: fonts.proxima
  },
  Title: {
    fontFamily: fonts.proxima
  },
  Text: {
    maxWidth: "32em"
  },
  buttons: {
    primary: {
      padding: 0,
      borderBottom: "1px solid",
      fontWeight: "400",
      fontFamily: fonts.proxima,
      backgroundColor: "transparent"
    }
  },
  space,
  letterSpacings: ["0.024px", "0.60px"],
  lineHeights: ["12px", "16px", "24px", "32px", "48px", "64px"],
  fonts
};
